import { Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import '../src/scss/app.scss';
import 'react-toastify/dist/ReactToastify.css';
import LayoutRoute from './components/layout';
import { ToastContainer } from 'react-toastify';
import Login from './pages/auth/login';
import NewPassword from './pages/auth/newpassword/NewPassword';
import Changepassword from './pages/auth/changepassword/Changepassword';
import SuccessForm from './pages/auth/changepassword/SuccessForm';
import ForgotPassword from './pages/auth/forgotpassword/ForgotPassword';
import PrivateRoute from './routes/PrivateRoute';
import Notification from './pages/notification/notificationPage';
import LandingPage from './pages/landing';
import ViewPrivacy from './pages/policy/PrivacyNotices/View';
import ViewHR from './pages/policy/HRPrivacyPolicy/ViewHR';
import ViewVendor from './pages/policy/VenderPrivacyPolicy/ViewVendor';
import ViewRecruitment from './pages/policy/RecruitmentPolicy/ViewRecruitment';
import DSRequestForm from './pages/ds-request-form/DSForm/Steps';
import ThankYouPage from './pages/ds-request-form/ThankYouPage';
import OpenSourceNotices from './pages/openSourceNotices';
import PackageExpired from './pages/auth/PackageExpired';
import PackageNotAvailable from './pages/auth/PackageNotAvailable ';
import TermCondition from './pages/template-design/components/Template/TermCondition';
import Consent from './pages/template-design/components/Template/Consent';
import ViewCookie from './pages/policy/CookiesPolicy/ViewCookie';
import ViewCCTV from './pages/policy/CCTVPolicy/ViewCCTV';
import ViewFreeForm from './pages/policy/FreeForm/View';
import { ROUTER } from './constants/router';
import View from './pages/data-breach/View';
import InvalidLink from './pages/invalidLink';
import AccountNotFound from './pages/account-not-found';
import MaintenancePage from './pages/maintenance/MaintenancePage';
import { Navigate } from 'react-router-dom';

const isUnderMaintenance = process.env.REACT_APP_UNDER_MAINTENANCE === 'true';
const days = parseInt(process.env.REACT_APP_COUNTDOWN_DAYS || '0', 10);
const hours = parseInt(process.env.REACT_APP_COUNTDOWN_HOURS || '0', 10);
const mins = parseInt(process.env.REACT_APP_COUNTDOWN_MINS || '0', 10);
const secs = parseInt(process.env.REACT_APP_COUNTDOWN_SECS || '0', 10);
const now = new Date();
const targetDate = new Date(
    now.getTime() +
        (((days * 24 + hours) * 60 + mins) * 60 + secs) * 1000
);
const supportEmail = process.env.REACT_APP_SUPPORT_EMAIL || 'support@example.com';
function App() {
    if (isUnderMaintenance) {
        return (
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<MaintenancePage supportEmail={supportEmail} logoText={'WF'} companyName={'Whitefact G-able'} />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </BrowserRouter>
        );
    }
    return (
        <Suspense fallback="...is loading">
            <ToastContainer />
            <BrowserRouter>
                <Routes>
                    <Route element={<NewPassword />} path="/new-password/:id" />
                    <Route
                        element={<ForgotPassword />}
                        path="/forgot-password/:id"
                    />
                    <Route element={<ViewPrivacy />} path="/external-privacy" />
                    <Route element={<ViewHR />} path="/external-hr-privacy" />
                    <Route
                        element={<ViewVendor />}
                        path="/external-vendor-privacy"
                    />
                    <Route
                        element={<ViewRecruitment />}
                        path="/external-recruitment-privacy"
                    />
                    <Route
                        element={<ViewCookie />}
                        path="/external-cookie-policy"
                    />
                    <Route
                        element={<ViewCCTV />}
                        path="/external-cctv-policy"
                    />
                    <Route
                        element={<ViewFreeForm />}
                        path="/external-free-form"
                    />
                    <Route
                        element={<DSRequestForm />}
                        path="/:lang/ds-request-form/:domainId"
                    />
                    <Route
                        element={<ThankYouPage />}
                        path="/thank-you-page/:lang"
                    />
                    <Route
                        element={<TermCondition />}
                        path="/term-and-condition/:lang/:key"
                    />
                    <Route element={<Consent />} path="/consent/:lang/:key" />
                    {/* View data breach */}
                    <Route path={ROUTER.DATA_BREACH.VIEW} element={<View />} />
                    <Route element={<Login />} path="/login" />

                    <Route
                        path="/"
                        element={
                            <PrivateRoute>
                                <LandingPage />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/package-expired"
                        element={
                            <PrivateRoute>
                                <PackageExpired />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/package-not-available"
                        element={
                            <PrivateRoute>
                                <PackageNotAvailable />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/changepassword"
                        element={
                            <PrivateRoute>
                                <Changepassword />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/successfully"
                        element={
                            // <PrivateRoute>
                            <SuccessForm />
                            // </PrivateRoute>
                        }
                    />
                    <Route
                        path="/notification"
                        element={
                            <PrivateRoute>
                                <Notification />
                            </PrivateRoute>
                        }
                    />

                    <Route
                        path="/user-not-found"
                        element={
                            <PrivateRoute>
                                <AccountNotFound />
                            </PrivateRoute>
                        }
                    />

                    <Route path="/invalid-link" element={<InvalidLink />} />

                    {/* Private Route */}

                    <Route
                        path="*"
                        element={
                            <PrivateRoute>
                                <LayoutRoute />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/open-source"
                        element={<OpenSourceNotices />}
                    />
                    {/* Private Route */}
                </Routes>
            </BrowserRouter>
        </Suspense>
    );
}

export default App;
